module.exports = __webpack_public_path__ + "media/_archive/R-cfbc52aa.png";